const prefix = '/api';

const api = {
  login: `${prefix}/login`,
  signUp: `${prefix}/user`,
  duplication: `${prefix}/user/duplication`,
  findId: `${prefix}/user/find/id`,
  findPassword: `${prefix}/user/find/password`,
  changePassword: `${prefix}/user/change/find/password`,
  join: `${prefix}/user`, // 회원가입
  isPushUpdate: `${prefix}/user/push`, // 푸시 알림변경

  // 개인정보 수정페이지
  reqAuthCode: `${prefix}/auth/send`,
  confirmAuthCode: `${prefix}/auth/match`,
  detail: userNo => `${prefix}/user/${userNo}`,
  updatePhoneNumber: `${prefix}/user/change/phone`,
  updatePassword: `${prefix}/user/change/password`,

  logout: `${prefix}/logout`,

  // 메인페이지
  main: `${prefix}/main`
};

export default {
  ...api
};
